import { useEffect, useState } from 'react';
import { useTranslation } from 'i18n';
import { msUntil } from 'services/deals';

const pad = (n) => (n <= 9 ? `0${n}` : `${n}`);

/** "Deal ends in HH:MM:SS" (total hours). Calls onEnd at 0 and renders
 * nothing from then on -- never shows 00:00:00. */
export default function DealCountdown({ endsAt, onEnd, className = '' }) {
  const { t } = useTranslation();
  const [left, setLeft] = useState(() => msUntil(endsAt));

  useEffect(() => {
    setLeft(msUntil(endsAt));
    const id = setInterval(() => {
      const next = msUntil(endsAt);
      setLeft(next);
      if (next === 0) {
        clearInterval(id);
        if (typeof onEnd === 'function') onEnd();
      }
    }, 1000);
    return () => clearInterval(id);
  }, [endsAt, onEnd]);

  if (left <= 0) return null;
  const total = Math.ceil(left / 1000); // rounds up: never reads 00:00:00
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return (
    <div
      data-testid="deal-countdown"
      className={`inline-flex items-center gap-2 rounded-full bg-slate-900 px-3 py-1 text-xs font-semibold text-white ${className}`}
    >
      <span className="uppercase tracking-[0.2em]">{t('deals.endsIn')}</span>
      <span dir="ltr" className="font-mono tabular-nums">{`${pad(h)}:${pad(m)}:${pad(s)}`}</span>
    </div>
  );
}
